import {Branch} from "../../model/Branch";
import './branch-address.dialog.component.scss';
import {BranchesAddressService} from "../../../branches_service/service/branches-address.service";
import {BranchAddressServiceName} from "../../../utils/names/serviceNames";
import {Address} from "../../../address/model/Address";
import angular = require("angular");

export class BranchAddressDialogComponent {

    public static instance = (event, branch: Branch): angular.material.IDialogOptions => ({
        parent: angular.element(document.body),
        controller: [
            'branch',
            BranchAddressServiceName,
            '$mdDialog',
            BranchAddressDialogComponent],
        targetEvent: event,
        controllerAs: '$ctrl',
        clickOutsideToClose: true,
        template: require('./branch-address.dialog.component.html'),
        locals: {
            branch: branch,
        }
    });

    constructor(private branch: Branch,
                private branchesAddressService: BranchesAddressService,
                private mdDialog: angular.material.IDialogService) {
    }

    private showLoader: boolean;

    submit = (verifiedAddress: Address) => {
        this.executeSubmit(verifiedAddress);
    };

    forceSubmit = (address: Address) => {
        this.mdDialog.show(this.getConfirmDialog())
            .then(() => this.executeSubmit(address));
    };

    private getConfirmDialog(): angular.material.IConfirmDialog {
        return this.mdDialog.confirm()
            .multiple(true)
            .title('Are you sure you want to submit unvalidated branch address?')
            .textContent('You are about to save your changes. \n' +
                'However, this branch address was not verified. \n' +
                'If you take \'Send Physical Letter\' action, \n' +
                'your sender address will be automatically waterfalled to either brand or corporate address. \n' +
                'You can update your address at any time. \n' +
                'Are you sure you want to proceed?')
            .ok('Yes, I am sure')
            .cancel('No, I changed my  mind');
    }

    private executeSubmit = (verifiedAddress: Address) => {
        this.showLoader = true;
        verifiedAddress.id = this.branch.address.id;
        this.branchesAddressService.updateAddress(
            this.branch.id, verifiedAddress)
            .then(resp => {
                this.showLoader = false;
                if (resp.status === 200) {
                    this.mdDialog.hide(resp.data);
                }
            });
    };

    closeModal = () => {
        this.mdDialog.cancel();
    }

}